import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HttpService from '../services/HttpServices';

const apiService = HttpService;

// Initial state of the slice
const initialState = {
  
  stockDetails: [], // Details of a single stock
  loading: false,
  error: null,
  stockPageInfo:{}
};

// Async thunk for fetching stocks for the inbox
export const fetchstocks = createAsyncThunk(
  'stock/fetchstocks',
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get('/stocks',
        { params: queryParams },
      );
      return response.data;
    } catch (error) {
      console.log("error : ", error)
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

// The stock slice
export const stockSlice = createSlice({
  name: 'stock',
  initialState,
  reducers: {
    resetStockState: (state) => {
      state.stockDetails = [];
      state.loading = false;
      state.error = null;
      state.stockPageInfo = {}
    },
  },
  extraReducers: (builder) => {
    builder
      // Handling fetchstocks
      .addCase(fetchstocks.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchstocks.fulfilled, (state, action) => {
        state.loading = false;
        state.stockDetails = action.payload.data;
        state.stockPageInfo = {
          totalRecords : action.payload.totalRecords
        }
      })
      .addCase(fetchstocks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
  },
});



// Export actions and reducer
export const { resetStockState } = stockSlice.actions;
export default stockSlice.reducer;
